import { useFetch } from "~vue/api";
import type { Connection } from "~vue/types/connection";
import { computed, ref } from "vue";

export const useConnectionsSearch = () => {
    const searchQuery = ref("");
    const fetchUrl = computed(() => {
        const baseUrl = "/api/connections/";
        if (!searchQuery.value) {
            return baseUrl;
        }
        const params = new URLSearchParams({ search: searchQuery.value });
        return `${baseUrl}?${params.toString()}`;
    });

    const {
        data: connections,
        isFetching: isFetchingConnections,
        error: connectionsFetchError,
        execute: fetchConnections,
    } = useFetch(fetchUrl, { refetch: true }).get().json<Connection[]>();

    return { connections, isFetchingConnections, searchQuery, connectionsFetchError, fetchConnections };
};
